// extracted by mini-css-extract-plugin
module.exports = {"status":"_fb71260","tennis":"_9909de2","football":"_b8fc315","eventStartDate":"_ea58de4"};